import Link from "next/link";

import { Button, css, styled } from "@mui/material";

import { getColor } from "@hooks";

export const CTAContainer = styled("div")`
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow-x: hidden;
`;

export const WrapperWithLines = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 1.5rem 0;
`;

export const LinesContainer = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex-shrink: 0;
  width: 268px;
`;

interface LineProps {
  side: "left" | "right";
  linePosition: "start" | "center" | "end";
}

export const Line = styled("div", {
  shouldForwardProp: prop => prop !== "side" && prop !== "linePosition",
})<LineProps>(({ theme, side, linePosition }) => {
  const gradientRotation = side === "left" ? 90 : 270;

  return css`
    position: relative;
    height: 1px;
    width: 100%;
    background: ${theme.palette.mode === "light"
      ? `linear-gradient(${gradientRotation}deg, #f5f7fa 0%, ${getColor(c => c.tokens.bg["soft-200"], theme)} 100%)`
      : `linear-gradient(${gradientRotation}deg, #181b25 0%, ${getColor(c => c.tokens.bg["soft-200"], theme)} 100%)`};

    &::after {
      position: absolute;
      content: "";
      height: 1px;
      width: 16px;

      left: ${linePosition === "start"
        ? 0
        : linePosition === "center"
          ? "calc(50% - 8px)"
          : "calc(100% - 16px)"};

      background: ${getColor(
        c =>
          side === "left" ? c.colors.main.flatleft : c.colors.main.flatright,
        theme,
      )};
      box-shadow: 0px 1px 3px 0px
        ${getColor(
          c =>
            side === "left"
              ? c.tokens.casestudy.agile.lighter
              : c.tokens.casestudy.embedded.lighter,
          theme,
        )};
    }
  `;
});

export const CTALink = styled(Link)(
  ({ theme }) => css`
    flex-shrink: 0;
    padding: 0 24px;
    border: 1px solid ${getColor(c => c.tokens.bg["soft-200"], theme)};
    border-top: none;
    border-bottom: none;
  `,
);

export const CTAButton = styled(Button)(
  ({ theme }) => css`
    border: 2px solid ${getColor(c => c.tokens.stroke["soft-200"], theme)};

    ${theme.palette.mode === "light" &&
    css`
      background-color: ${getColor(c => c.tokens.bg["white-0"], theme)};
      color: ${getColor(c => c.tokens.text["strong-950"], theme)};
      &:hover {
        background-color: ${getColor(c => c.tokens.bg["weak-50"], theme)};
      }
    `}
  `,
);
